import React, { useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from '../../hooks/usePermission';
import TeamForm from '../../Components/Teams/TeamForm';
import TeamTable from '../../Components/Teams/TeamTable';
import { CreateTeamsPermission } from '../../constants/permissions';

const Teams = () => {
    const { data: canCreateTeam } = usePermission({
        permissionName: CreateTeamsPermission
    });

    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null) 
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        division_id: '',
        created_at: new Date().toISOString(),
        updated_at: null,
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: '',
            description: '',
            division_id: '',          
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleEdit = (teamData) => {
        setEditData(teamData)
        setFormData({
          name: teamData.name || "",
          description: teamData.description || "",
          division_id: teamData.division_id || "",
          created_at: teamData.created_at || new Date().toISOString(),
          updated_at: teamData.updated_at || null,
        })
        setOpen(true)
      }

    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h4" component="h1">
                        Teams
                    </Typography>
                    {canCreateTeam && (
                        <button
                            className='bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2'
                            onClick={handleClickOpen}
                        >
                            <AddIcon />
                            Add New Team
                        </button>
                    )}
                </Box>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TeamTable handleEdit={handleEdit} editData={editData} />
                </Paper>

                <TeamForm
                    open={open}
                    onClose={handleClose}
                    formData={formData}
                    onInputChange={handleInputChange}
                    editData={editData}
                />
            </Box>
        </Container>
    );
};

export default Teams; 